module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_8003.6c6f1de7.png";